import React, { useState , useEffect} from "react";
import axios from "axios";
import { TextField, Button, FormGroup, InputLabel, Grid, } from "@mui/material"; 
import {API_URL} from "../constants";
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router';
import { useSnackbar } from "notistack";


export default function AccountCreation() {
    //state variables for objects
    const [FirstName, setFirstName] = useState("");
    const [LastName, setLastName] = useState("");
    const [Email, setEmail] = useState("");
    const user = useSelector(state => state.user.user);
    const navigate = useNavigate();
    const { enqueueSnackbar } = useSnackbar();
  

    const createUser = (e) => {
        e.preventDefault();
        axios.post(`${API_URL}/user/create`, {FirstName, LastName, Email}).then(res=> {
                console.log(res.data);
                enqueueSnackbar('User Created and email sent with credentials', {variant: 'success'});
        }).catch(ex => {
                console.log(ex);
        })
    }

    const handleFirstNameChange = (e) => {
        setFirstName(e.target.value);
    }
    const handleLastNameChange = (e) => {
        setLastName(e.target.value);
    }
    const handleEmailChange = (e) => {
        setEmail(e.target.value);
    }

    useEffect(() => {
        console.log('User: ',user);
        if (user.IsAdmin || user.IsVendorAdmin) {
          //good
        }
        else{
            navigate('/login');
        }
      }, []);
    
    return(
        <div className="container" style={{paddingTop:125, paddingRight: 200, paddingLeft:200}}>
           <form onSubmit={createUser}>
           <Grid container spacing="2" paddingX={2}>
                    <Grid item lg={12} md={10} sm={10} paddingBottom={2}>
                        <FormGroup>
                            <InputLabel>First Name:</InputLabel>
                            <TextField name="FirstName" onChange={e => handleFirstNameChange(e)} variant="outlined" placeholder="Enter First Name"/>
                        </FormGroup>
                    </Grid>
                    <Grid item lg={12} md={10} sm={10} paddingBottom={2}>
                        <FormGroup>
                            <InputLabel>Last Name:</InputLabel>
                            <TextField name="LastName" onChange={e => handleLastNameChange(e)} variant="outlined" placeholder="Enter Last Name"/>
                        </FormGroup>
                    </Grid>
                    <Grid item lg={12} md={10} sm={10} paddingBottom={2}>
                        <FormGroup>
                            <InputLabel>Email:</InputLabel>
                            <TextField name="Email" onChange={e => handleEmailChange(e)} variant="outlined" placeholder="Enter Email"/>
                        </FormGroup>
                    </Grid>
                    <Grid item lg={12} md={10} sm={10} paddingBottom={2}>
                        <Button type="submit" onClick={createUser}>Create User</Button>
                    </Grid>
            </Grid>
           </form>
        </div>
    )
}